export enum ResultStatus {
  SUCCESS,
  FAIL,
}

export interface Result {
  status: ResultStatus;
  error?: any;
}
